import { ArrowCta } from '@mc/certificates-design-system'
import { useTranslation } from '@mc/i18n'
import Link from 'components/Link'
import { useSignup } from 'pages/certificates/components/SignUpButton'
import { TrackClick } from 'pages/certificates/tracking'

export const CertificateSignupCTA = ({ subtext }: { subtext?: string }) => {
  const { t } = useTranslation('@mc/certificates')
  const { fullHref, trackQuizExposure } = useSignup({})

  return (
    <div className='d-flex flex-column align-items-center'>
      <TrackClick event='purchaseClick'>
        <ArrowCta
          render={<Link href={fullHref} />}
          onClick={trackQuizExposure}
          kind='accent'
          className='d-flex align-items-center justify-content-center'
        >
          {t('marketingPages.common.signUpNow')}
        </ArrowCta>
      </TrackClick>

      {subtext && (
        <span className='mc-text-x-small c-text-sohne-mono mc-text--uppercase c-text-color--light c-mt-2'>
          {subtext}
        </span>
      )}
    </div>
  )
}
